import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import LevelSelector from "./LevelSelector";
import ReportTypeSelector from "./ReportTypeSelector";

export default function Header(props) {
  const {
    getAdvancedReportInfo,
    getIconComponent,
    getReportList,
    isRTL,
    onLevelChange,
    onReportChange,
    reportLevels,
    reportsLoading,
    selectedLevel,
    selectedReport,
    t,
    availableReports,
  } = props;

  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={1}>
      <Box>
        <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
          {t("reports.reportLevel", "مستوى التقرير")}
        </Text>
        <LevelSelector
          getIconComponent={getIconComponent}
          isRTL={isRTL}
          onChange={onLevelChange}
          reportLevels={reportLevels}
          selectedLevel={selectedLevel}
          t={t}
        />
      </Box>
      <Box>
        <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
          {t("reports.reportType", "نوع التقرير")}
        </Text>
        <ReportTypeSelector
          availableReports={availableReports}
          getAdvancedReportInfo={getAdvancedReportInfo}
          getReportList={getReportList}
          isRTL={isRTL}
          onChange={onReportChange}
          reportsLoading={reportsLoading}
          selectedReport={selectedReport}
          t={t}
        />
      </Box>
    </SimpleGrid>
  );
}
